import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";

const Ctx = createContext(null);
export const usePortalAuth = () => useContext(Ctx);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, object = auth

  useEffect(() => {
    const t = localStorage.getItem("op_portal_token");
    if (!t) { setUser(false); return; }
    portalApi.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("op_portal_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await portalApi.post("/auth/login", { email, password });
    localStorage.setItem("op_portal_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem("op_portal_token"); setUser(false); };

  const refreshUser = async () => {
    try { const { data } = await portalApi.get("/auth/me"); setUser(data); return data; } catch { return null; }
  };

  return <Ctx.Provider value={{ user, login, logout, refreshUser }}>{children}</Ctx.Provider>;
}

export function PortalRoot() {
  return <PortalAuthProvider><Outlet /></PortalAuthProvider>;
}

export function ProtectedRoute({ children, adminOnly }) {
  const { user } = usePortalAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen bg-[#F4EFE6] flex items-center justify-center text-[#8a7a6a] font-body">Loading…</div>;
  if (!user) return <Navigate to="/portal/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/portal" replace />;
  return children;
}
